<template>
	<div class="w-100 text-center ">
		<!-- <div class="w-100 mb-3">
			<div class="row no-gutters">
				<div class="col-8 text-center">
					<img src="../../assets/img/icon/payment/qris.png" class="mt-2" height="60">
				</div>
				<div class="col-4 text-center">
					<img src="../../assets/img/icon/payment/gnp.png" height="60">
				</div>
			</div>
		</div> -->
		<div class="w-75 mx-auto bg-qris">
			<div class="w-100 mb-1">
				<p class="body-1-2 mb-0">{{data.merchantName}}</p>
				<p class="body-3 mb-0">NMID: {{data.nmid}}</p>
				<!-- <p class="body-2 mb-0">A01</p> -->
			</div>
			<img class="w-100" id="QRtoPRINT" :src="data.qris_url">
			<p class="body-3 text-10 text-dark text-left pl-3 mb-0">Dicetak oleh : {{data.printed_by}}</p>
		</div>
		<div class="d-table mx-auto text-center border border-green radius-6 mb-2 py-1 px-2" @click="DownloadQRCode" :class="{'cursor-pointer':!is_downloading}">
			<pulse-loader :loading="is_downloading" v-if="is_downloading" />
			<p v-else class="text-green body-3 mb-0">{{$t('payment-result.download-qr-code')}}</p>
		</div>
		<div class="w-100 mb-3 mx-auto py-3 border-bottom">
			<p class="sub-heading-1-2 mb-1">{{formatCurrency(data.totalAmount)}}</p>
			<p class="body-3 text-dark mb-0">{{$t('payment-result.ref-id')}}: {{data.billNumber}}</p>
			<p class="body-3 text-dark mb-0">{{$t('payment-result.expired')}}: {{data.expiredDate}} WITA</p>
		</div>
		<div class="w-100 mb-3 mx-auto py-3">
			<p class="body-3 text-dark mb-1">{{$t('payment-result.support-by')}} :</p>
			<img src="../../assets/img/icon/logo-bpd.png" class="mb-3" height="60">

			<p class="body-3 text-dark mb-1">{{$t("qris.scan-qr-with-app")}}</p>
			<div class="w-100 d-inline-block align-middle">
				<img src="../../assets/img/icon/payment/bpd_mobile.png" class="mr-1" height="20">
				<img src="../../assets/img/icon/payment/bca_mobile.png" class="mr-1" height="20">
				<img src="../../assets/img/icon/payment/ovo.png" class="mr-1" height="20">
				<img src="../../assets/img/icon/payment/shopee.png" class="mr-1" height="20">
				<img src="../../assets/img/icon/payment/gopay.png" class="mr-1" height="20">
				<img src="../../assets/img/icon/payment/dana.png" class="mr-1" height="20">
				<img src="../../assets/img/icon/payment/linkaja.png" class="mr-1" height="20">
			</div>
		</div>


		<!-- <div class="w-75 mb-3 mx-auto">
			<p class="body-2 mb-0">
				Lakukan pembayaran sebelum
			</p>
			<div class="w-100 d-table">
				<p class="sub-heading-1-2 mb-0">{{data.expiredDate}}</p>
			</div>
		</div> -->
	</div>
</template>
<script>
	import {mapGetters} from 'vuex';
	import {formatCurrency,formatDate} from '@/utils/index.js';
	import domtoimage from 'dom-to-image';
	export default {
		props: ['data'],
		data() {
			return{
				is_downloading: false
			}
		},
		mounted(){
			console.log("QRIS DATA : ", this.data)
		},
		methods: {
			...mapGetters(['getTicketPayment']),
			formatDate(date){
        return formatDate(date);
      },
      formatCurrency(value){
        return formatCurrency(value);
      },
      DownloadQRCode() {
      	if(!this.is_downloading){
      		this.is_downloading = true
	      	let self = this;
	        domtoimage.toJpeg(document.getElementById('QRtoPRINT'), { quality: 1 })
	        .then(function (dataUrl) {
	            var link = document.createElement('a');
	            link.download = 'QRIS-'+self.data.merchantName+'.jpeg';
	            link.href = dataUrl;
	            link.click();
	            self.is_downloading = false
	        });
      	}
      },
      get8FirstChar(data){
      	return data.substring(0,8)
      }
		}
	}
</script>
<style scoped>
	.border-green{
    border-color: rgb(170, 212, 106) !important;
  }
  .bg-qris{
  	background-image: url("../../assets/img/icon/payment/template.png");
  	background-size: contain;
  	background-position: center;
		background-repeat: no-repeat;
		padding: 90px 25px 30px 25px;
  }
</style>


// WEBPACK FOOTER //
// src/components/ticket/QrisForm.vue